import { getUrlByEnvironment } from "auth0/auth0";

type checkBreakitUserResponse = {
  isExistingBreakitCustomer: boolean;
};

export async function fetchIsExistingBreakitCustomerByEmail(email: string) {
  const res = await fetch(
    `${getUrlByEnvironment()}/api/check-email-entitlements-breakit?email=${encodeURIComponent(
      email,
    )}`,
  );

  const response = await res.json();

  const { isExistingBreakitCustomer } = response as checkBreakitUserResponse;

  console.log("isExistingBreakitCustomer", isExistingBreakitCustomer);

  return isExistingBreakitCustomer;
}

// API helpers---------------------------------------------------------
const clientId = "login2";
const clientSecret = process.env.LOGIN2_TOKEN_SERVICE_CLIENT_SECRET;

export async function getSesamyToken() {
  if (!clientSecret) {
    throw new Error("LOGIN2_TOKEN_SERVICE_CLIENT_SECRET not set");
  }
  const formData = new URLSearchParams();
  formData.set("client_id", clientId);
  formData.set("client_secret", clientSecret);
  formData.set("grant_type", "client_credentials");
  formData.set(
    "scope",
    "profile:user:read profile:user-vendors:read vault:read vault:impersonate",
  );

  const response = await fetch(`${process.env.SESAMY_TOKEN_URL}/oauth/token`, {
    method: "POST",
    body: formData.toString(),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch token");
  }

  const body = await response.json();
  const token = body.access_token;
  const timestamp = Date.now() + body.expires_in * 1000;

  return { token, timestamp };
}

interface UserLookupResult {
  id: string;
  userId: string;
  hasPrimaryAddress: boolean;
}

export async function getProfileIdentity(email: string, token: string) {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/profile/email/${encodeURIComponent(
      email,
    )}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "user-agent": "login2",
      },
    },
  );

  if (response.status === 404) {
    return null;
  }

  if (!response.ok) {
    throw new Error(`Failed to fetch user profile`);
  }

  const user: UserLookupResult = await response.json();

  return user.id;
}
